import { render, staticRenderFns } from "./SupportSheetComponent.vue?vue&type=template&id=34dc64d4&scoped=true&"
import script from "./SupportSheetComponent.vue?vue&type=script&lang=ts&"
export * from "./SupportSheetComponent.vue?vue&type=script&lang=ts&"
import style0 from "./SupportSheetComponent.vue?vue&type=style&index=0&id=34dc64d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34dc64d4",
  null
  
)

export default component.exports